import { Edit } from "react-admin";
import { JobApplicationSourceForm } from "./index";
import { EditToolbar } from "@components/EditToolbar";

export const JobApplicationSourceEdit = () => (
  <Edit mutationMode="pessimistic">
    <JobApplicationSourceForm toolbar={<EditToolbar showDeleteButton={false} />} />
  </Edit>
);
